export const LinkTransactionCardViewTransactionAnalytics =
  'clicked_view_transaction_in_link_app';

export const LinkTransactionCardViewBlockchainAnalytics =
  'clicked_blockchain_transaction_link';
